
import { Dispatch } from '../architecture/frontend/index'

const Filter = (props) => {
  const type = props._view
  return (
    <form onSubmit={e => {
      e.preventDefault()
      const form = e.target;
      const element = form.elements['search'];
      const value = element.value
      Dispatch.nextAction('view', { type, details: value })
      // Clear out input box value
      element.value = ''
    }}>
      <input 
        className='ml2 h2 ph3 br2 f6 fw5 w4 bn evonik-purple' 
        style={{ outline: 'none', borderStyle: 'solid',  backgroundColor: 'white', paddingTop: 5, paddingBottom: 5}} 
        type="text" 
        name={'search'}
        placeholder={'Filter...'}
        // defaultValue={}
        // onChange={}
        
      />
    </form>
  )
}

export default Filter